export default "__VITE_ASSET__8an9rezR__"